import Logger from './toolkit/logger/Logger';

const configure = () => {
  let filter = process.env.REACT_APP_LOG_FILTER;
  filter = filter ? filter.toUpperCase() : 'OFF';
  const filterValue = Logger['LEVEL_' + filter];
  if (typeof filterValue === 'number') {
    Logger.filter(filterValue);
  }
}

export default configure;
